
// EditarCliente.js

import React, { useState, useEffect } from 'react';
import NameField from '../components/NameField';
import CodigoField from '../components/CodigoField';
import DatepickerField from '../components/DatepickerField';
import EmailField from '../components/EmailField';
import PhoneField from '../components/PhoneField';
import CnpjField from '../components/CnpjField';
import CpfField from '../components/CpfField';
import InscEstField from '../components/InscEstField';
import InscMunField from '../components/InscMunField';
import CepField from '../components/CepField';
import NumeroField from '../components/NumeroField';
import ComplementoField from '../components/ComplementoField';
import CurrencyField from '../components/CurrencyField';
import FormaPagamentoSelect from './FormaPagamentoSelect';
import CondPagamentoSelect from './CondPagamentoSelect';
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

function EditarCliente({ cliente, handleClienteEditado, handleCancelaEdit, isEditing }) {
  const [formData, setFormData] = useState(cliente);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setFormData(cliente);
  }, [cliente]);


  const paymentMethods = ['Em Espécie', 'PIX', 'Cartão', 'Boleto', 'Depósito', 'Transferência'];
  const conditionMethods = ['À Vista', '15 dias', '30 dias', '60 dias', '30-60 dias', '30-60-90 dias'];

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleAddressChange = (address) => {
    setFormData((prevData) => ({
      ...prevData,
      logradouro: address.logradouro,
      bairro: address.bairro,
      cidade: address.cidade,
      uf: address.uf,
    }));
  };


  // Função para obter a data atual no formato yyyy-mm-dd
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };


  const handleSaveClick = async () => {
    if (isSaving) {
      return;
    }

    const mandatoryFields = ['nomecli', 'codcli', 'fone', 'email','cnpjcli'];
  //  const hasErrors = mandatoryFields.some(field => formData[field]?.trim() === '');

  // Verificações específicas para cada campo obrigatório
  const hasErrors = mandatoryFields.some(field => {
    if (field === 'codcli') {
      return !formData[field] || typeof formData[field] !== 'number';
    } else {
      return !formData[field] || typeof formData[field] !== 'string' || formData[field].trim() === '';
    }
  });
  if (hasErrors) {
    alert('Os Campos: Nome, Código, Email, Fone e CNPJ são obrigatórios.');
    return;
  }

    
    // Se a data de cadastro estiver vazia, define a data atual
    if (!formData.dtcadastro.trim()) {
      formData.dtcadastro = getDataAtualISO();
    }


    setIsSaving(true);

    try {
      console.log('Enviando dados do cliente:', formData);
      const response = await api.put(`/clientes/alterarcliente/${cliente.id}`, formData, {
        headers: { 'Content-Type': 'application/json' },
      //, Authorization: `Bearer ${localStorage.getItem('token')}`  
      });
      console.log('Cliente editado com sucesso:', response.data);
      handleClienteEditado(response.data); // Atualiza a lista de clientes e redireciona
    } catch (error) {
      if (error.response) {
        console.log('Erro ao editar cliente:', error.response.data);
      } else {
        console.log('Erro ao editar cliente:', error.message);
      }
    } finally {
      setIsSaving(false);
    }
  };


  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}
    >

        <div style={{ marginBottom: '10px', marginTop: '10px' }}>
          <h3>Edição do Cliente</h3>
        </div>

        <div style={{ textAlign: 'left', marginLeft: '20px' }}>

          <div style={{ display: 'flex', marginBottom: '25px' }}>

            <div style={{ marginRight: '20px', width: '520px', height: '30px' }}>
              <label style={{ display: 'block', width: '520px' }}>Nome:</label>
              <NameField value={formData.nomecli} onChange={value => handleChange('nomecli', value)} />
            </div>
          
            <div style={{ width: '100px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '100px' }}>Código:</label>
              <CodigoField value={formData.codcli} readOnly />
            </div>
          
            <div style={{ width: '120px', height: '28px' }}>
              <label style={{ display: 'block', width: '150px',  marginBottom: '0px' }}>Data de Cadastro:</label>
              <DatepickerField  style={{ width: '120px', height: '28px' }} value={formData.dtcadastro} onChange={value => handleChange('dtcadastro', value)} />
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '25px' }}>
            <div style={{ width: '420px', height: '30px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '410px' }}>E-mail:</label>
              <EmailField value={formData.email} onChange={value => handleChange('email', value)} />
            </div>
            <div style={{ width: '200px', height: '30px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Telefone:</label>
              <PhoneField value={formData.fone} onChange={value => handleChange('fone', value)} />
            </div>
            <div style={{ width: '200px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Celular:</label>
              <PhoneField value={formData.celular} onChange={value => handleChange('celular', value)} />
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '25px' }}>
            <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px' }}>CNPJ:</label>
              <CnpjField value={formData.cnpjcli} onChange={value => handleChange('cnpjcli', value)} />
            </div>
            <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginRight: '20px' }}>CPF:</label>
              <CpfField value={formData.cpfcli} onChange={value => handleChange('cpfcli', value)} />
            </div>
            <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px', marginRight: '20px' }}>Inscrição Estadual:</label>
              <InscEstField value={formData.inscricaoest} onChange={value => handleChange('inscricaoest', value)} />
            </div>
            <div style={{ width: '200px', height: '30px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Inscrição Municipal:</label>
              <InscMunField value={formData.inscricaomun} onChange={value => handleChange('inscricaomun', value)} />
            </div>
          </div>

        <div style={{ display: 'flex', marginBottom: '0px', marginTop: '0px' }}>
          <div style={{ width: '120px', marginRight: '20px', marginBottom: '0px',marginTop: '0px' }}>
            <CepField 
            value={formData.cep} 
            onChange={value => handleChange('cep', value)} 
            onAddressChange={handleAddressChange}/>
          </div>

          <div style={{ width: '100px', marginRight: '20px', marginLeft: '440px' }}>
            <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Número:</label>
            <NumeroField value={formData.numero} onChange={value => handleChange('numero', value)} />
          </div>

          <div style={{ width: '160px' }}>
              <label style={{ display: 'block', width: '160px' }}>Complemento:</label>
              <ComplementoField value={formData.complemento} onChange={value => handleChange('complemento', value)} />
          </div>
        </div>

         
      <div style={{ display: 'flex', marginBottom: '25px' }}>
        <div style={{ width: '120px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '120px', marginBottom: '0px' }}>Crédito:</label>
          <CurrencyField value={formData.credito} onChange={value => handleChange('credito', value)} />
        </div>
                    
        <div style={{ width: '200px', marginLeft: '0px', marginBottom: '0px' }}>
         <FormaPagamentoSelect 
          paymentMethods={paymentMethods} 
          selectedMethod={formData.formapag} 
          onChange={(value) => handleChange('formapag', value)} 
        />
        </div>

        <div style={{ width: '230px', marginLeft: '20px', marginBottom: '0px' }}>
         <CondPagamentoSelect 
          conditionMethods={conditionMethods} 
          selectedMethod={formData.condpag} 
          onChange={(value) => handleChange('condpag', value)} 
        />
        </div>

        </div>

          <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
            <button  type="button" className='btn-menu' onClick={handleSaveClick} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
              {isSaving ? 'Salvando...' : 'Salvar'}
            </button>
            <button  type="button" className='btn-menu' onClick={handleCancelaEdit} style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>
              Cancelar
            </button>
            </div>
          </Box>

        </div>

      
    </div>
  );
};

export default EditarCliente;
